import { Container, Divider, Grid, Stack } from "@mui/material";
import { ReactElement } from "react";
import { TitleView } from "./TitleView";

interface props {
  title: string;
  titleLayout?: ReactElement;
  layout?: ReactElement;
  isLayoutFullWidthInSmallerScreens?: boolean;
  hasDivider?: boolean;
}

export const HeaderView: React.FC<props> = ({
  title,
  titleLayout,
  layout,
  isLayoutFullWidthInSmallerScreens = true,
  hasDivider = true,
}: props) => {
  return (
    <Stack>
      <Container maxWidth={false} sx={{ p: 2 }}>
        <Grid container spacing={2} alignItems={"center"}>
          <Grid
            size={{
              xs: isLayoutFullWidthInSmallerScreens ? 12 : 6,
              sm: isLayoutFullWidthInSmallerScreens ? 12 : 6,
              md: 6,
              lg: 6,
              xl: 3,
            }}
          >
            <Stack direction={"row"} alignItems={"center"} spacing={1}>
              <TitleView title={title} />
              {titleLayout}
            </Stack>
          </Grid>
          <Grid
            size={{ xl: 3 }}
            display={{
              xs: "none",
              sm: "none",
              md: "none",
              lg: "none",
              xl: "block",
            }}
          />
          <Grid
            size={{ xl: 3 }}
            display={{
              xs: "none",
              sm: "none",
              md: "none",
              lg: "none",
              xl: "block",
            }}
          />
          {layout && (
            <Grid
              size={{
                xs: isLayoutFullWidthInSmallerScreens ? 12 : 6,
                sm: isLayoutFullWidthInSmallerScreens ? 12 : 6,
                md: 6,
                lg: 6,
                xl: 3,
              }}
            >
              {layout}
            </Grid>
          )}
        </Grid>
      </Container>
      {hasDivider && <Divider />}
    </Stack>
  );
};
